import { createAsyncThunk } from "@reduxjs/toolkit";
import { updateMultiFilterByProvider } from "../../resourceExplorerSlice";
import {
  ResourceExplorerFilterItem,
  ProviderType,
} from "../../../../services/cloudchipr.api";
import { getResourceExplorerWidgetDataThunk } from "../widgets/getResourceExplorerWidgetDataThunk";
import { resourceExplorerFilterByKeyAndProviderSelector } from "../../selectors/filters/resourceExplorerFilterByKeyAndProviderSelector";
import { RootState } from "../../../store";

interface ProductFamilyFilterChangeThunkArg {
  filter: ResourceExplorerFilterItem;
  provider: ProviderType;
}

export const productFamilyFilterChangeThunk = createAsyncThunk(
  "resourceExplorer/ProductFamilyFilterChange",
  (
    { filter, provider }: ProductFamilyFilterChangeThunkArg,
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;
    const currentSavedFilter = resourceExplorerFilterByKeyAndProviderSelector(
      state,
      "product_family",
      provider,
    );
    if (!currentSavedFilter && !filter.value?.length) {
      return;
    }
    dispatch(
      updateMultiFilterByProvider({
        filter,
        provider,
      }),
    );
    dispatch(getResourceExplorerWidgetDataThunk());
  },
);
